import React, {useContext} from "react";
import {ViewMangementContext} from "../StatesMangement/InitialiseContext";
import './Common.css'

export default () => {
    // This Component is default Alert in this app.
    // This is custom Alert so we can change the Message(Text) in Alert and also we can change the Alert type.
    // Example :- Just call the function like this to show alert. "SETAlertProperty({Message: 'Any message', Type: 'warning', Show: true})"
    // Example :- Just call the function like this to hide alert. "SETAlertProperty({Message: '', Type: '', Show: false})"
    // 'Message' is use to pass the message, 'Type' is use to set the type or alert, 'Show' is use to hide and display the alert any time.
    // Types are limited. we can only use these types :- 'primary, secondary, success, danger, warning, info, light, dark'.
    // When we show the alert by default it hide itself after 3 seconds.
    let PageView = useContext(ViewMangementContext)
    const setAlertProperty = PageView.setAlertProperty
    const AlertProperty = PageView.AlertProperty
    let AlertClass = `alert alert-${AlertProperty.Type} alert-dismissible fade show col-11` // add col-11 for make responsive alerts on mobile view
    if (AlertProperty.Show) {
        return (
            <div className='shadow'>
                <div className={AlertClass} role="alert">
                    {AlertProperty.Message}
                    <button type="button" className="close" data-dismiss="alert" aria-label="Close"
                            onClick={() => setAlertProperty({Message: '', Type: '', Show: false})}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        );
    } else {
        return (<></>);
    }
}

